import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import Notificacoes from "../components/Notificacoes";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import AIConfig from "../pages/AIConfig/";
import Tags from "../pages/Tags";
import Chatbots from "../pages/Chatbots";
import ChatbotBuilder from "../pages/Chatbots/Builder";
import Agenda from "../pages/Agenda";
import Meta from "../pages/Meta";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { FavoritosProvider } from "../context/Favoritos/FavoritosContext";
import { FlutuantesProvider } from "../context/Flutuantes/FlutuantesContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <WhatsAppsProvider>
            <FavoritosProvider>
            <FlutuantesProvider>
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/cadastro" component={Signup} />
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/atendimentos/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/conexoes" component={Connections} isPrivate perfis={["admin", "operador"]} />
                <Route exact path="/contatos" component={Contacts} isPrivate />
                <Route exact path="/usuarios" component={Users} isPrivate perfis={["admin", "operador"]} />
                <Route exact path="/respostas-rapidas" component={QuickAnswers} isPrivate />
                <Route exact path="/configuracoes" component={Settings} isPrivate perfis={["admin", "operador"]} />
                <Route exact path="/filas" component={Queues} isPrivate />
                <Route exact path="/setores" component={Queues} isPrivate />
                <Route exact path="/chatbot-ia" component={AIConfig} isPrivate perfis={["admin"]} />
                <Route exact path="/meta" component={Meta} isPrivate perfis={["admin"]} />
                <Route exact path="/etiquetas" component={Tags} isPrivate />
                <Route exact path="/agenda" component={Agenda} isPrivate />
                <Route exact path="/fluxos-visuais" component={Chatbots} isPrivate perfis={["admin"]} />
                <Route exact path="/fluxos-visuais/:id/builder" component={ChatbotBuilder} isPrivate perfis={["admin"]} />
              </LoggedInLayout>
            </Switch>
            </FlutuantesProvider>
            <Notificacoes />
            </FavoritosProvider>
          </WhatsAppsProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
